import { createContext, useEffect } from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import { useAsyncState } from '@hilma/tools';
import { useSocket } from '@hilma/socket.io-react';

export const PurchaseJwtContext = createContext<string | null>(null);
export const SetPurchaseJwtContext = createContext<((value: React.SetStateAction<string | null>, callback?: ((state: string | null) => void) | undefined) => Promise<string | null>) | null>(null);

const PurchaseJwtProvider: React.FC = ({ children }) => {
	const [purchaseJwt, setPurchaseJwt, getPurchaseJwt] = useAsyncState<string | null>(null);

	const socket = useSocket();

	useEffect(() => {
		if (!purchaseJwt) return;

		socket.emit('jwt-created', purchaseJwt);

		socket.on('connect', () => {
			socket.emit('jwt-created', purchaseJwt);
		});

		return () => {
			socket.off('connect');
			socket.emit('jwt-deleted', purchaseJwt);
		}
	}, [purchaseJwt]);

	useEffect(() => {
		const purchaseJwtId = axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
			const purchaseJwt = await getPurchaseJwt();
			if (purchaseJwt) config.headers.authorization = purchaseJwt;
			return config;
		});

		return () => {
			axios.interceptors.request.eject(purchaseJwtId);
		}
	}, []);

	return (
		<PurchaseJwtContext.Provider value={purchaseJwt}>
			<SetPurchaseJwtContext.Provider value={setPurchaseJwt}>
				{children}
			</SetPurchaseJwtContext.Provider>
		</PurchaseJwtContext.Provider>
	);
}

export default PurchaseJwtProvider;